import React, { useEffect, useRef } from "react";
import * as OktaSignIn from "@okta/okta-signin-widget";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import { oktaConfig } from "../../config/okta.config";

const OktaSignInWidget = ({ onSuccess, onError }) => {
    const widgetRef = useRef();

    useEffect(() => {
        if (!widgetRef.current) return false;

        const { issuer, clientId, scopes, redirectUri } = oktaConfig.oktaAuth;
        const widget = new OktaSignIn({
            baseUrl: issuer.split("/oauth2")[0],
            clientId,
            redirectUri,
            logo: require("../../assets/images/logo5.png").default,
            i18n: {
                en: {
                    "primaryauth.title": "Sign in to NeoSpectra Portal",
                },
            },
            authParams: {
                issuer,
                scopes,
            },
            features: {
                showPasswordToggleOnSignInPage: true,
                idpDiscovery: true,
            },
            idpDiscovery: {
                requestContext: `${window.location.origin}/login/customcallback`,
            },
            useInteractionCodeFlow: false, // Set to true, if your org is OIE enabled
        });

        widget
            .showSignInToGetTokens({
                el: widgetRef.current,
            })
            .then(onSuccess)
            .catch(onError);

        return () => widget.remove();
    }, [onSuccess, onError]);

    return <div ref={widgetRef} />;
};

export default OktaSignInWidget;
